import { useEffect, useRef, useState } from "react";
import {
  ControlLayoutType,
  TableAStateType,
  TableBStateType,
} from "../types/RequestScreenContext.type";
import { Form27TableRowEditorDialog } from "../components/Form27TableRowEditorDialog";
import { useForm27RequestScreenContext } from "./RequestScreenContext.hook";
import { log } from "console";
import _, { isEqual } from "lodash";

export function useForm27TableB({
  templateId,
  controlLayout,
  tableB,
  onChangeHandler,
}: Readonly<{
  templateId: number;
  controlLayout: ControlLayoutType;
  tableB?: TableBStateType;
  onChangeHandler: (rows: any[]) => void;
}>) {
  const TEMPLATE_ID = 27;
  const TABLE_NAME = "ข้อมูลใบวางบิลสำหรับใช้ออกงบใบสำคัญ";
  if (
    TEMPLATE_ID != templateId ||
    TABLE_NAME != controlLayout?.template?.label
  ) {
    // nothing todo
    return;
  }
  const requestScreen = useForm27RequestScreenContext();
  const [layout, setLayout] = useState<ControlLayoutType>(controlLayout);
  const [editorDialog, setEditorDialog] = useState<{
    visible: boolean;
    row?: { index: number; data: any; object: any };
    tableData: any[];
  }>({
    visible: false,
    tableData: [],
  });

  const tableAData = useRef<any[]>([]);
  const tableBData = useRef<any[]>([]);

  useEffect(() => {
    setLayout(controlLayout);
  }, [controlLayout]);


  useEffect(() => {
    if (requestScreen?.hasUpdate) {
      const mapColumns = [
        { a: "CatagolyGroupName", b: "หมวดวัสดุ" },
        { a: "InculdVat", b: "จำนวนเงิน" },
        { a: "ExculdVat", b: "จำนวนเงินก่อน VAT" },
        { a: "Vat", b: "ภาษีมูลค่าเพิ่ม" },
        { a: "BankAccountCode", b: "รหัสบัญชี" },
        { a: "FullPlanCode", b: "รหัสแผนงาน" },
        { a: "SoFCode", b: "รหัสแหล่งเงิน" },
        { a: "Depcode", b: "Depcode" },
        { a: "Depname", b: "หน่วยงาน" },
      ];

      const employeeData = JSON.parse(
        localStorage.getItem("userData") || "{}"
      ).employeeData;

      const targetTable = _.isEqual(requestScreen.tableA , requestScreen.tableB) || _.isEmpty(requestScreen.tableB) ? requestScreen.tableA: requestScreen.tableB;

      const _tableData =
        targetTable?.raw?.map((row, i) => {
          // data injection
          row.Depcode = employeeData?.DepartmentCode;
          row.Depname = employeeData?.DepartmentNameTh;

          const columns =
            layout.template?.attribute?.column?.map((column) => {
              const label =
                mapColumns.find((map) => map.b == column.label)?.a ||
                column.label;
              let value = row[label];
              if (
                value == null &&
                column?.control?.template?.attribute?.default
              ) {
                value = column?.control?.template?.attribute?.default;
              }
              return { [column.label]: value };
            }) || [];
          const newRow = Object.assign({ key: i + 1 }, ...columns);

          return newRow;
        }) ||
        targetTable?.data  || [];

      tableBData.current = _tableData ?? [];
      const hasUpdate2 = sessionStorage.getItem("setHasUpdate2")

      if (hasUpdate2 === "true") {
        onChangeHandler(_tableData);
        requestScreen?.setHasUpdate(false);
      }
    }
  }, [requestScreen?.tableB,requestScreen?.hasUpdate]);

  useEffect(() => {
    const CheckAddRow = sessionStorage.getItem("handleAddRow");
    if (Object.keys(requestScreen?.tableB || {}).keys.length === 0) {
      const mapColumns = [
        { a: "CatagolyGroupName", b: "หมวดวัสดุ" },
        { a: "InculdVat", b: "จำนวนเงิน" },
        { a: "ExculdVat", b: "จำนวนเงินก่อน VAT" },
        { a: "Vat", b: "ภาษีมูลค่าเพิ่ม" },
        { a: "BankAccountCode", b: "รหัสบัญชี" },
        { a: "FullPlanCode", b: "รหัสแผนงาน" },
        { a: "SoFCode", b: "รหัสแหล่งเงิน" },
        { a: "Depcode", b: "Depcode" },
        { a: "Depname", b: "หน่วยงาน" },
      ];
      const employeeData = JSON.parse(
        localStorage.getItem("userData") || "{}"
      ).employeeData;

      const _tableData = requestScreen?.tableA?.raw?.map((row, i) => {
          // data injection
          row.Depcode = employeeData?.DepartmentCode;
          row.Depname = employeeData?.DepartmentNameTh;

        const columns = layout.template?.attribute?.column?.map((column) => {
            const label = mapColumns.find((map) => map.b == column.label)?.a || column.label;
              let value = row[label];
            if (value == null && column?.control?.template?.attribute?.default) {
                value = column?.control?.template?.attribute?.default;
              }
              return { [column.label]: value };
            }) || [];
          const newRow = Object.assign({ key: i + 1 }, ...columns);
          return newRow;
        }) || [];

      if (tableBData.current == _tableData) {
        tableBData.current = _tableData;
        onChangeHandler(_tableData);
        requestScreen?.setHasUpdate(false);
      } else {
        if (CheckAddRow === "true") {
          tableBData.current = _tableData;
          onChangeHandler(_tableData);
          requestScreen?.setHasUpdate(false);
          sessionStorage.removeItem("handleAddRow");
        }
      }
    }
  }, [requestScreen?.tableA]);

  function openEditor(key: number, tableData: any) {
    let row = findRowByKey(key, tableData);
    if (row == null) {
      row = { index: tableData.length ?? 0, data: {}, object: {} };
    }
    const custom = layout.custom[row.index] || {};
    row.data = {
      ...(custom || row.data),
      key: key,
    };

    setEditorDialog((prv) => ({ ...prv, visible: true, row: row, tableData }));
  }

  function findRowByKey(key: number, tableData: any[]) {
    const index = tableData.findIndex((row) => row.key == key);
    if (index == -1) {
      return null;
    }
    const data = tableData[index];
    return { index, data, object: tableB?.raw?.at(index) };
  }

  return {
    isActive: true,
    openEditor,
    component: {
      Form27TableRowEditorDialog: Form27TableRowEditorDialog({
        visible: editorDialog.visible,
        setVisible: (visible: boolean) =>
          setEditorDialog((prv) => ({ ...prv, visible })),
        row: editorDialog.row,
        onSubmit: (data: any) => {
          setEditorDialog((prv) => ({ ...prv, visible: false }));
          const rowData = {
            ...data,
            หมวดวัสดุ: data["ประเภทรายการ"],
            จำนวนเงิน: (data["จำนวนเงิน"] ?? "").toString().replace(",", ""),
          };
          const _tableData = JSON.parse(JSON.stringify(editorDialog.tableData));
          const tableAIndex = _tableData?.findIndex(
            (row: any) => row.key == data.key
          );
          if (tableAIndex != -1) {
            _tableData[tableAIndex] = rowData;
          } else {
            rowData.key = Date.now();
            _tableData.push(rowData);
          }
          onChangeHandler([..._tableData]);
          setLayout((prv) => ({ ...prv, custom: _tableData }));
        },
      }),
    },
  };
}
